(function() {
    'use strict';
    var flkty = new Flickity('.co-home-3 .main-carousel', {
        selectedAttraction: 0.01,
        cellAlign: 'left',
        friction: 0.2,
        pageDots: false,
        wrapAround: true,
        draggable: true,
        prevNextButtons: true,
        arrowShape: ''
    });
    const TRANSLATE_TARGET_CLASS = '.co-home-3 .carousel-cell-transform-1';
    const TRANSLATE_Y_PREV = '-40px';
    const TRANSLATE_Y_NEXT = '-60px';
    function parseValue(value) {
    const match = value.match(/^(-?\d*\.?\d+)(.*)$/);
    return {
        number: parseFloat(match[1]),
        unit: match[2] || ''
    };
    }
    function calculateTranslateY(slide, viewport) {
    const slideRect = slide.getBoundingClientRect();
    const viewportRect = viewport.getBoundingClientRect();
    const slideCenterX = slideRect.left + slideRect.width / 2 - viewportRect.left;
    const viewportCenter = viewport.offsetWidth / 2;
    const slideWidth = slideRect.width;
    const distanceFromCenter = (slideCenterX - viewportCenter) / slideWidth;
    let value = 0;
    let unit = '';
    const prev = parseValue(TRANSLATE_Y_PREV);
    const next = parseValue(TRANSLATE_Y_NEXT);
    if (distanceFromCenter >= 1 && distanceFromCenter <= 2) {
        const progress = distanceFromCenter - 1;
        value = next.number * (1 - progress);
        unit = next.unit;
    } else if (distanceFromCenter >= 0 && distanceFromCenter < 1) {
        value = next.number * distanceFromCenter;
        unit = next.unit;
    } else if (distanceFromCenter >= -2 && distanceFromCenter <= -1) {
        const progress = Math.abs(distanceFromCenter) - 1;
        value = prev.number * (1 - progress);
        unit = prev.unit;
    } else if (distanceFromCenter >= -1 && distanceFromCenter < 0) {
        value = prev.number * Math.abs(distanceFromCenter);
        unit = prev.unit;
    }
    return `${value}${unit}`;
    }
    function updateSlideEffects() {
    const viewport = flkty.viewport;
    flkty.cells.forEach((cell) => {
        const slide = cell.element;
        const translateTarget = slide.querySelector(TRANSLATE_TARGET_CLASS);
        
        if (translateTarget) {
        const translateY = calculateTranslateY(slide, viewport);
        translateTarget.style.transform = `translateY(${translateY})`;
        }
    });
    }
    flkty.on('select', updateSlideEffects);
    flkty.on('dragMove', updateSlideEffects);
    flkty.on('scroll', updateSlideEffects);
    updateSlideEffects();
})();
// ============================================= GSAP
gsap.registerPlugin(ScrollTrigger);
// ====================================== ====================================== ====================================== SECTION 1
gsap.to(".co-home-3-bg", {
  scrollTrigger: {
    trigger: ".co-home-3",
    start: "top bottom",
    end: "bottom top",
    scrub: 1
  },
  yPercent: -20
});